var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "q-table-container no-shadow q-table-dense" },
    [
      _c("div", { staticClass: "q-table-middle scroll" }, [
        _c(
          "table",
          { staticClass: "q-table q-table-horizontal-separator no-shadow" },
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th", {
                    staticClass: "text-left",
                    staticStyle: { width: "80px" }
                  }),
                  _vm._l(_vm.validColumns, function(column) {
                    return _c("th", {
                      key: column.field,
                      staticClass: "text-left",
                      domProps: { textContent: _vm._s(column.label) }
                    })
                  }),
                  _vm.showEdit
                    ? _c("th", {
                        staticClass: "text-center",
                        staticStyle: { width: "80px" }
                      })
                    : _vm._e(),
                  _vm.showDelete
                    ? _c("th", {
                        staticClass: "text-center",
                        staticStyle: { width: "80px" }
                      })
                    : _vm._e()
                ],
                2
              )
            ]),
            _c(
              "tbody",
              _vm._l(_vm.rows, function(row, index) {
                return _c(
                  "tr",
                  { key: row.id },
                  [
                    _c(
                      "td",
                      {
                        staticClass: "text-left",
                        staticStyle: { width: "80px" }
                      },
                      [
                        _c("q-icon", {
                          class: {
                            invisible: _vm.selectedRowIds.indexOf(row.id) === -1
                          },
                          attrs: { name: "check circle", color: "positive" }
                        })
                      ],
                      1
                    ),
                    _vm._l(_vm.validColumns, function(column) {
                      return _c(
                        "td",
                        {
                          key: "row-" + row.id + "-" + column.field,
                          staticClass: "text-left cursor-pointer",
                          on: {
                            click: function($event) {
                              return _vm.handleSelect(index)
                            }
                          }
                        },
                        [
                          column.field === "imageUrl"
                            ? _c("span", [
                                _c("img", {
                                  staticClass: "flex inline flex-center",
                                  staticStyle: {
                                    "max-height": "36px",
                                    width: "auto"
                                  },
                                  attrs: {
                                    src: _vm._f("relationLabel")(
                                      row,
                                      column,
                                      _vm.parentColumnMap[column.field]
                                    )
                                  }
                                })
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("relationLabel")(
                                      row,
                                      column,
                                      _vm.parentColumnMap[column.field]
                                    )
                                  )
                                )
                              ])
                        ]
                      )
                    }),
                    _c(
                      "td",
                      {
                        staticClass: "text-center",
                        staticStyle: { width: "80px" }
                      },
                      [
                        _vm.showEdit
                          ? _c("q-btn", {
                              attrs: {
                                icon: "edit",
                                color: "positive",
                                flat: "",
                                round: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleEdit(index)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "text-center",
                        staticStyle: { width: "80px" }
                      },
                      [
                        _vm.showDelete
                          ? _c("q-btn", {
                              attrs: {
                                icon: "delete",
                                color: "negative",
                                flat: "",
                                round: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(index)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  2
                )
              }),
              0
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }